import { inject, Injectable } from '@angular/core';
import { FirebaseService } from '../../common/firebase/firebase.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CreateReviewFancyDto } from '@/app/common/general-types/reviews.dto';

@Injectable({
  providedIn: 'root'
})
export class ReviewsFancyService {

  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);

  getReviews(uid: string, take: number, skip: number) {
    const creator_reviews_url = `${environment.shout_api.url}/review-fancy/creator/${uid}?take=${take}&skip=${skip}`;
    return this.http.get(creator_reviews_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  createReview(newReview: CreateReviewFancyDto) {
    const create_review_url = `${environment.shout_api.url}/review-fancy`;
    return this.http.post(create_review_url, newReview, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
}
